<template>
    <layout name="LayoutDefault">
        <div class="About">
            <!-- Page Content -->
            <div class="container">
                <!-- Page Features -->
                <div class="contents">
                    <div class="row  text-justify">
                        <div class="col-lg-12">
                            <div v-if="content" class="tangon" v-html="content"></div>
                            <p v-else>Content coming soon...</p>
                        </div>
                    </div>

                </div>
            </div>
            <!-- /.container -->
        </div>
    </layout>
</template>

<script>
    import Layout from '../layouts/Layout';

    export default {
        name: `Terms`,
        data() {
            return {
                content: ''
            };
        },
        components: {
            Layout,
        },
        methods: {
            getContent() {
                fetch(this.APIURL + 'cms-resources/Terms')
                    .then(response => response.json())
                    .then(json => {
                        if (json.data && json.data.length > 0) {
                            this.content = json.data[0].description;
                        }
                    })
                    .catch(() => {});
            }
        },
        mounted() {
            this.getContent();
        }
    };
</script>
